import { accountRoute } from 'account/common/helper/AccountRoute';
import { Home } from 'application/components/Main/Home';
import { CategoryList } from 'category/components/List/CategoryList';
import { CommonRouteNames } from 'common/contact/common/model/CommonRouteNames';
import { ContactList } from 'common/contact/components/List/ContactList';
import { AdminRouteNames } from 'common/model/AdminRouteNames';
import { CorporateIdentityList } from 'corporateIdentity/List/CorporateIdentityList';
import { FileList } from 'files/List/FileList';
import { OrderList } from 'order/components/List/OrderList';
import { PostList } from 'post/components/List/PostList';
import { ProductList } from 'product/components/List/ProductList';
import { Navigate } from 'react-router-dom';
import { Settings } from 'settings/Form/SettingsForm';
import { SliderList } from 'slider/components/List/SliderList';
import { createRoute } from './createRoute';

export const branchRoutes = createRoute([
  {
    path: AdminRouteNames.HOME,
    element: <Home />,
  },
  {
    path: AdminRouteNames.PRODUCT,
    element: <ProductList />,
  },
  {
    path: AdminRouteNames.CATEGORY,
    element: <CategoryList />,
  },
  {
    path: AdminRouteNames.ORDER,
    element: <OrderList />,
  },
  {
    path: AdminRouteNames.SLIDER,
    element: <SliderList />,
  },
  {
    path: AdminRouteNames.SETTING,
    element: <Settings />,
  },
  {
    path: AdminRouteNames.CORPORATEL_IDENTITY,
    element: <CorporateIdentityList />,
  },
  {
    path: AdminRouteNames.POST,
    element: <PostList />,
  },
  {
    path: AdminRouteNames.FILES,
    element: <FileList />,
  },
  {
    path: CommonRouteNames.CONTACT,
    element: <ContactList />,
  },
  {
    path: `${AdminRouteNames.ACCOUNT}/*`,
    element: accountRoute,
  },
  {
    path: '*',
    element: <Navigate to={AdminRouteNames.HOME} replace={true} />,
  },
]);
